
/* global CookieControl */

const i = {
  t: function(t) {
    const e = 'https://attachments-ldn.imiengage.io/widgeteu/js/imichatinit.js';
    try {
      const o = new XMLHttpRequest();
      o.onreadystatechange = function() {
        if (this.readyState == 4) {
          const t = document.getElementById('divicw');
          if (this.status == 0) {
            i.o(t);
            return;
          }
          const e = document.createElement('script');
          e.innerHTML = this.responseText;
          t.parentNode.insertBefore(e, t.nextSibling);
        }
      }
      ;
      o.open('GET', e, true);
      o.send();
    } catch (s) {
      console.error(s);
    }
  },
  o: function(t) {
    // eslint-disable-next-line max-len
    t.insertAdjacentHTML('afterend', '<iframe id="tls_al_frm" frameborder="0" style="overflow: hidden;height: 208px;width: 394px;position: fixed;display: block;right: 48px;bottom: 12px;z-index: 99999; display:none;"></iframe>');
    const e = document.getElementById('tls_al_frm');
    // eslint-disable-next-line max-len
    const o = e.contentWindow || e.contentDocument.document || e.contentDocument;
    o.document.open();
    // eslint-disable-next-line max-len
    o.document.write('<!doctype html><html><head><meta charset="utf-8"><title>Untitled Document</title><style>body{font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;color: #99a0b0;font-size: 14px;}.popover__content{background-color: #fbfbfe; padding: 1.5rem; border-radius: 5px; width: 300px; box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);position: relative;}.popover__message{font-weight: 600;color:#56627c;font-size: 16px;}.pull-left{float:left;}.clearfix{clear: both;}.hdr-txt{width: 218px; margin-top: 3px;}.para-txt a{text-decoration: none;color: #005cde;}.close-btn{position: absolute;right:15px;top:15px;}.close-btn a{text-decoration: none;font-weight: 400; color: #56627c; font-size: 16px;}</style></head><body><div class="popover__content"><div class="close-btn"><a href="#" onclick="closeTLSAlert();">X</a></div><div class="popover__message"><div class="pull-left hdr-txt">This browser version is not supported on LiveChat.</div></div><div class="clearfix"></div><p class="para-txt">Please update your browser to the latest version and re-open the website to access the widget. </p></div><script>function closeTLSAlert(){window.parent.postMessage({key: "close_tls_alert",value: "close_tls_alert",action: "close_tls_alert"}, "*");}<\/script></body></html>');
    o.document.close();
    e.style.display = 'block';
    window.addEventListener('message', function(t) {
      if (t.data.action == 'close_tls_alert') {
        i.s();
      }
    });
  },
  s: function() {
    const t = document.getElementById('tls_al_frm');
    t.remove();
  },
};

/**
 * Appends the WebChat to the body element.
 */
function appendWebChat() {
  i.t(function(t) { });
};


// eslint-disable-next-line require-jsdoc, prefer-rest-params, brace-style
function gtag() {dataLayer.push(arguments);};

const analyticsStatement = 'Analytics cookies collect information in an ' +
  'anonymous form and help us understand how you use our website, like ' +
  'which pages you visit and how long you stay on them. We use this ' +
  'information to compile reports and help us improve the website and your ' +
  'browsing experience.\n\n' +
  'Marketing cookies track your interests across different websites and show ' +
  'you ads that are more relevant to you. This means you\'ll see ads for ' +
  'products and services you\'re likely to be interested in, both on our ' +
  'website and on other websites. \n\n' +
  'You can learn more about how we use cookies and manage your preferences ' +
  'any time on our Privacy and Cookies page.';

/**
 * Function to set up Google Tag Manager.
 * This function is called when the user accepts the optional cookies.
 * It sets up the Google Tag Manager script.
 */
const tagManagerSetup = function() {
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      'event': 'gtm.js',
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-T7F2CQQ');
};

const tagManagerCookies = [
  'MUID', 'MUIDB', '_ga', '_gat_UA-2818637-2', '_gcl_au', '_gid'];

// Are there any cookies used by the webchat?
const webChatCookies = [];

const webchatDescription = 'Our live chat feature does not use cookies, ' +
  'making it more private and secure for you. Instead, it stores ' +
  'information directly in your browser. You can opt in or out of the live ' +
  'chat at any time right here.';

const strNotifyDescription = 'We use cookies on our website to allow us to ' +
  'continuously improve our site and enhance your experience. You can use ' +
  'this tool to easily manage your cookie preferences, otherwise please ' +
  'click Accept Recommended Settings to let us know you’re happy for us to ' +
  'continue';

const strIntro = 'Some of these cookies are essential, while others help us ' +
  'to improve your experience by providing insights into how the site is ' +
  'being used. ' +
  'We also use enhanced conversion tracking to show you more relevant ads ' +
  'based on your interests; this uses a secure hashing process to anonymise ' +
  'your data. '+
  'You can always choose to opt out of cookies or tracking altogether ' +
  'through your browser settings. \n' +
  'By clicking Accept Recommended Settings you are consenting ' +
  'to the use of cookies while you’re on our website';

const strNecessaryDescription = 'Necessary cookies enable core functionality ' +
  'such as page navigation. The website cannot function properly without ' +
  'these cookies, and can only be disabled by changing your browser ' +
  'preferences.';

/**
 * Configuration object for the Civic Cookie Control script.
 *
 */
const config = {
  apiKey: '9728c8367e6e58d9ad9ce9126ed3355fc73aa45f',
  product: 'PRO_MULTISITE',

  necessaryCookies: [
    'has_js',
    'BIGipServerLTE-WS-04-Pool',
    'banner_dismissed',
    'csrftoken',
    'sessionid',
    'django_language',
  ],

  statement: {
    description: 'You can always change your mind. For more information, please see our',
    name: 'Privacy and Cookies page',
    url: '/dataprotection/',
    updated: '05/08/2024',
  },

  optionalCookies: [{
    name: 'analytics',
    label: 'Analytics / Personalised Ads',
    description: analyticsStatement,
    cookies: [
      'CONSENT', 'NID', 'SAPISID', 'SSID']
        .concat(tagManagerCookies),
    onAccept: function() {
      tagManagerSetup();

      gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
      });
    },
    onRevoke: function() {
      gtag('consent', 'update', {
        'analytics_storage': 'denied',
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
      });
    },

    thirdPartyCookies: [{
      name: 'Double click',
      optOutLink: 'https://ico.org.uk/your-data-matters/online/cookies/',
    }],

    recommendedState: true,
  },
  {
    name: 'webchat',
    label: 'Live Chat',
    description: webchatDescription,
    cookies: webChatCookies,
    onAccept: function() {
      appendWebChat();
    },
    onRevoke: function() {
      // removeWebchat();
    },
    recommendedState: true,
  }],

  initialState: 'notify',
  layout: 'popup',
  theme: 'DARK',
  position: 'right',

  text: {
    accept: 'Accept Recommended Settings',
    settings: 'Preferences',
    notifyDescription: strNotifyDescription,
    intro: strIntro,
    necessaryDescription: strNecessaryDescription,
  },

  branding: {
    fontFamily: '"Montserrat", sans-serif',
    fontColor: '#fff',
    fontSizeTitle: '1.3em',
    fontSizeIntro: '1.1em',
    fontSizeHeaders: '1.1em',
    fontSize: '0.9em',
    acceptText: '#fff',
    acceptBackground: '#00abb5',

    backgroundColor: '#3c3c3b',
    toggleText: '#fff',
    toggleColor: '#3c3c3b',
    toggleBackground: '#00abb5',
    buttonIcon: null,
    buttonIconWidth: '64px',
    buttonIconHeight: '64px',
    removeIcon: true,
    removeAbout: true,
  },
};

/**
 * Function to load the Civic Cookie Control script.
 *
 */
export default function civicCookie() {
  // Define dataLayer and the gtag function.
  window.dataLayer = window.dataLayer || [];

  // Set default consent to 'denied'
  gtag('consent', 'default', {
    'ad_storage': 'denied', // advertising
    'ad_user_data': 'denied', // advertising
    'ad_personalization': 'denied', // remarketing
    'analytics_storage': 'denied', // analytics
  });

  const cookieScript = document.createElement('script');
  cookieScript.src = 'https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js';
  cookieScript.onload = function() {
    CookieControl.load(config);
  };
  document.body.appendChild(cookieScript);
};
